import { ServiceRequestRepository } from './ServiceRequestDebitStatementRepository'
import ServiceRequestModel from '../../../../ServiceRequestModel'
import { JtechStore } from 'src/plugins/mobx'
import router from 'src/router'

export default class ServiceRequestDebitStatementController {
  state = ServiceRequestModel.getInstance();

  static getInstance () {
    return JtechStore.getSingleton('ServiceRequestDebitStatementController', new ServiceRequestDebitStatementController())
  }

  async loadDebitStatementForm () {
    return await ServiceRequestRepository.loadDebitStatementForm()
  }
}
